if (!customElements.get('pdp-routine')) {
  customElements.define(
    'pdp-routine',
    class PdpRoutine extends HTMLElement {
      connectedCallback() {
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.message = this.querySelector('.pdp-routine__message');
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const singleButton = event.target.closest('[data-routine-add]');
        const allButton = event.target.closest('[data-routine-add-all]');
        if (singleButton && !singleButton.disabled) {
          this.addToCart([singleButton.dataset.routineAdd], singleButton);
        } else if (allButton) {
          const variantIds = Array.from(this.querySelectorAll('.pdp-routine__step[data-variant-id]')).map(
            (step) => step.dataset.variantId
          );
          if (variantIds.length) this.addToCart(variantIds, allButton);
        }
      }

      addToCart(variantIds, button) {
        if (button.getAttribute('aria-disabled') === 'true') return;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        button.querySelector('.loading__spinner')?.classList.remove('hidden');
        this.showMessage('');

        const body = { items: variantIds.map((id) => ({ id: Number(id), quantity: 1 })) };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement?.(document.activeElement);
        }

        const config = fetchConfig('json');
        config.body = JSON.stringify(body);

        fetch(`${routes.cart_add_url}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'pdp-routine',
                productVariantId: variantIds[0],
                errors: response.errors || response.description,
                message: response.message,
              });
              this.showMessage(response.description || response.message, true);
              return;
            }

            const items = response.items || [];
            // One event per line so add_to_cart tracking (datalayer-cart.js) and cart listeners treat it like a PDP add.
            items.forEach((item) => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: String(item.variant_id),
                cartData: { ...item, quantity: 1 },
                inProductInfo: true,
                inQuickAddModal: false,
              });
            });

            const template = items.length > 1 ? this.dataset.successMultiple : this.dataset.successSingle;
            this.showMessage((template || '').replace('[count]', items.length));

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (response.sections) {
              this.cart.classList.remove('is-empty');
              this.cart.renderContents({ ...response, id: items[0]?.id, key: items[0]?.key });
            }
          })
          .catch((error) => {
            console.error(error);
            this.showMessage(window.cartStrings?.error || '', true);
          })
          .finally(() => {
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            button.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      showMessage(text, isError = false) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.hidden = !text;
        this.message.classList.toggle('pdp-routine__message--error', isError);
      }
    }
  );
}
